import React, { useState } from "react";

import { useSelector } from "react-redux";
import { getFormValues } from "redux-form";

import {
	Modal,
	Button,
	ProgressIndicator
} from "rhombus-react";

import { VERSION_STATUS } from "utils/constants";

import { EDIT_VERSION_BLADE_FORM } from "widgets/forms/list";
import InfoBanner from "widgets/InfoBanner";
import DisplayPreview from "widgets/modals/previews/DisplayPreview";
import AdjustFramingBlade from "widgets/modals/versions/refinement/AdjustFramingBlade";

export default function InlineVersionPreview(props){
	let {
			libraryId,
			currentVariableInfo,
			creative,
			navigationActions,
			commonModalProps,
			versionInfo,
			saveAsVersion,
			saveVersion,
			disableSaveButtons,
			pushModal,
			variableConfig,
		} = props
		, { popModal } = navigationActions
		, shouldDisplayBanner = (versionInfo?.status === VERSION_STATUS.LIVE)
		, [isSaving, setIsSaving] = useState(false)
		, formValues = useSelector(getFormValues(EDIT_VERSION_BLADE_FORM)) || {};

	function closeModal() {
		popModal();
	}

	function onSave(values) {
		setIsSaving(true);
		saveVersion(values);
	}


	function Content() {
		return (
			<div className="main-content">
				<ProgressIndicator isLoading={isSaving} />
				{shouldDisplayBanner && <InfoBanner warning={{ description: "Saving will update the current live version." }} />}
				<DisplayPreview
					creative = {{
						...creative,
						id:creative.id,
						versionInfo:currentVariableInfo,
					}}
					libraryId = {libraryId}
					creativeId = {creative.id}
				/>
			</div>
		);
	}

	function adjustFraming() {
		function Configured(props) {
			let modalProps = {
				...props,
				variableConfig,
				libraryId,
				versionInfo,
				isOnTopOfPreviewBlade: true,
				commonModalProps: {
					...commonModalProps,
				},
			};

			return <AdjustFramingBlade {...modalProps} />;
		}

		pushModal(Configured);
	}

	function Footer() {
		return (
			<>
				<Button theme="default" className="cypress-preview-version-blade-back" onClick={closeModal}>Back</Button>
				<div className="footer-actions">
					<Button
						className="cypress-preview-open-smart-framing-blade"
						onClick={adjustFraming}>Adjust Framing</Button>
					<Button
						disabled={disableSaveButtons}
						className="cypress-preview-version-save-as"
						onClick={saveAsVersion}>Save As...</Button>
					<Button
						disabled={disableSaveButtons}
						theme="green"
						className="cypress-preview-save-version"
						onClick={() => onSave(formValues)}>Save Version</Button>
				</div>
			</>
		);
	}

	let modalProps = {
		...commonModalProps,
		title: `Preview Version - ${name}`,
		className: "edit-version-preview-blade inline-preview-display",

		renderContent: Content,
		renderFooter: Footer,

		onClose: closeModal,
	};

	return <Modal {...modalProps} />;
}
